import typetopia from './TypeTopia';
import keyvaluestore from './KeyValueStore';
window.TypeTopia = typetopia;
window.KeyValueStore = keyvaluestore;
